import React from "react";
import '../../../styles/cards.css'

function Card(props){
    return(
        <div className="card">
            <img draggable="false" className="img-team" src={props.img} alt="ISTE Team"/>
            <dt>
                <span>{props.name}</span>
            </dt>
            <dd>{props.designation}</dd>
        </div>
    );
}

export default Card;